import { render, staticRenderFns } from "./CompactDialer.vue?vue&type=template&id=2716980f&scoped=true"
import script from "./CompactDialer.vue?vue&type=script&lang=js"
export * from "./CompactDialer.vue?vue&type=script&lang=js"
import style0 from "./CompactDialer.vue?vue&type=style&index=0&id=2716980f&prod&scoped=true&lang=css"
import style1 from "./CompactDialer.vue?vue&type=style&index=1&id=2716980f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2716980f",
  null
  
)

export default component.exports